module.exports = __webpack_public_path__ + "static/img/sjq.27c7a965.svg";